document.addEventListener('alpine:init', () => {
  // console.log(Alpine.store('ProductForm'));

  Alpine.data('ProductForm', () => ({
    formEl: null,
    init() {
      this.formEl = this.$root.querySelector('form');
      this.productFormElement = this.$el;
      this.formEl.addEventListener('submit', this.submit.bind(this));
    },
    async submit(event) {
      event.preventDefault();
      
      this.$root.dispatchEvent(
        new CustomEvent('baseline:productform:loading', {
          bubbles: true,
        })
      );

      event.preventDefault();

      liveRegion(window.theme.strings.loading);

      const formData = new FormData(event.target);
      const formId = event.target.getAttribute('id');

      const options = fetchConfigDefaults('application/javascript');

      formData.append('sections', 'cart-items,cart-footer,cart-item-count');
      formData.append('sections_url', window.location.pathname);

      options.body = formData;
      options.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete options.headers['Content-Type'];

      window.__cartMutationSeq = (window.__cartMutationSeq || 0) + 1;
      const mySeq = window.__cartMutationSeq;

      let response, data;

      response = await fetch(`${theme.routes.cart_add_url}`, options);
      data = await response.json();



      if (data.status) {
        let errors = data.errors || data.description;
        let message = data.description || data.message;

        this.$root.dispatchEvent(
          new CustomEvent('baseline:productform:error', {
            detail: {
              sourceId: formId,
              variantId: formData.get('id'),
              errors,
              message,
            },
            bubbles: true,
          })
        );
      } else {

        const currentVariantId = formData.get('id');
        const CartNotifyEvent = new CustomEvent('productAdded', { detail: { data, currentVariantId }, bubbles: true });
        document.dispatchEvent(CartNotifyEvent);


        // UPDATE ICON GLOBAL SECONDARY STARTS HERE

        this.cartNotifyHead = document.querySelectorAll('.icon-cart__notification, .cart-icon--main');
        this.cartNotifyNum = document.querySelectorAll('.cart-qty__header');
        if (this.cartNotifyNum.length > 0) {
          const htmlString = data.sections['cart-item-count'];
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlString, 'text/html');
          const totalCartItems = (doc?.querySelector('div')?.textContent || '').trim();
          // console.log(totalCartItems, "TOTAL CART ITEMS PARSED HTML");
          let parsedTotalCartItems = parseInt(totalCartItems);
          if (parsedTotalCartItems >= 0 && this.cartNotifyHead) {
            this.cartNotifyHead?.forEach(head => {
              // console.log(head, "HEAD");
              if (!head.classList.contains('icon-cart__icon--active')) {
                head.classList.add('icon-cart__icon--active');
              }
            });
          } else { }
          const tempDivCount = doc.querySelector('div');
          this.cartNotifyNum?.forEach(element => {
            element.innerHTML = tempDivCount.innerHTML;
          });
        }

        // UPDATE ICON GLOBAL SECONDARY ENDS HERE


        this.$root.dispatchEvent(
          new CustomEvent('baseline:productform:success', {
            bubbles: true,
          })
        );

        if (mySeq === window.__cartMutationSeq) {
          // If a newer cart mutation (e.g. removing/changing an item in the
          // cart) has started since this add began, this response is stale —
          // applying it now would revert totals/progress bars to old data.
          document.body.dispatchEvent(
            new CustomEvent('baseline:cart:afteradditem', {
              bubbles: true,
              detail: { response: data, productFormElement: this.productFormElement },
            })
          );
        }
      }
    },
  }));
});
